import { Size as ScreenSize } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import { useEffect, useRef } from 'react';

import useLayoutEffect from '@swf/core/hooks/useIsomorphicLayoutEffect';

const useOnMobileBreakpointChange = (callback: (isMobile: boolean) => void) => {
  const { greaterThan } = useScreenSize();
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    callbackRef.current(!greaterThan(ScreenSize.Small));
  }, [greaterThan]);
};

export default useOnMobileBreakpointChange;
